import React, { useState } from 'react';
import ColorPickerPopover from '../../ChartOptions/Color/ChartColorComponents/ColorPickerPopover';

interface ColorPickerProps {
  label: string;
  color: string;
  isOpen: boolean;
  onToggle: () => void;
  onColorChange: (color: string) => void;
  lableColor?: string;
}

const ColorPicker: React.FC<ColorPickerProps> = ({
  label,
  color,
  isOpen,
  onToggle,
  onColorChange,
  lableColor,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    onToggle();
  };

  return (
    <>
      <div
        className="optionDescription"
        style={{
          marginTop: '8px',
          display: 'block',
          alignItems: 'center',
          color: lableColor,
        }}
      >
        <span>{label}</span>
        <div
          style={{
            marginTop: '10px',
            height: '1.25rem',
            width: '100px',
            backgroundColor: color,
            border: '2px solid darkgray',
            cursor: 'pointer',
            borderRadius: '4px',
            transition: 'all 0.2s ease',
          }}
          onClick={handleClick}
        />
      </div>
      <ColorPickerPopover
        isOpen={isOpen}
        onClose={onToggle}
        currentColor={color}
        onColorChange={onColorChange}
        propKey="buttonContentColor"
        onBackgroundColorChange={() => {}}
        selectedMenu="solid"
        anchorEl={anchorEl}
      />
    </>
  );
};

export default ColorPicker;
